// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

erpnext.show_quality_inspection_dialog = function (qi_names, frm) {
	let idx = 0;

	const next = async () => {
		if (idx >= qi_names.length) {
			frm.reload_doc();
			return;
		}

		const qi_name = qi_names[idx];
		const { message: qi_doc } = await frappe.call({
			method: "frappe.client.get",
			args: { doctype: "Quality Inspection", name: qi_name },
		});

		if (!qi_doc) {
			idx++;
			next();
			return;
		}

		// Seed per-row accepted flag from the existing status (default: Accepted)
		const readings_data = (qi_doc.readings || []).map((r) => ({
			...r,
			status_accepted: r.status !== "Rejected" ? 1 : 0,
		}));
		const has_readings = readings_data.length > 0;
		const total = qi_names.length;
		const is_last = idx === total - 1;
		let action_taken = false;
		// Track overall status via a local variable instead of relying on a hidden field
		let selected_status = qi_doc.status === "Rejected" ? "Rejected" : "Accepted";

		const fields = [
			{
				fieldtype: "HTML",
				fieldname: "item_info",
				options: `<div style="margin-bottom:12px">
					<strong>${frappe.utils.escape_html(qi_doc.item_code)}</strong>
					${qi_doc.item_name ? " &mdash; " + frappe.utils.escape_html(qi_doc.item_name) : ""}
				</div>`,
			},
		];

		if (has_readings) {
			fields.push({
				fieldtype: "Table",
				fieldname: "readings",
				label: __("Readings"),
				cannot_add_rows: true,
				in_place_edit: true,
				data: readings_data,
				get_data: () => readings_data,
				fields: [
					{
						fieldtype: "Data",
						fieldname: "specification",
						label: __("Parameter"),
						in_list_view: 1,
						read_only: 1,
						columns: 3,
					},
					{
						fieldtype: "Data",
						fieldname: "value",
						label: __("Criteria"),
						in_list_view: 1,
						read_only: 1,
						columns: 3,
					},
					{
						fieldtype: "Data",
						fieldname: "reading_1",
						label: __("Reading"),
						in_list_view: 1,
						columns: 4,
					},
					{
						fieldtype: "Check",
						fieldname: "status_accepted",
						label: __("Accepted"),
						in_list_view: 1,
						columns: 2,
					},
				],
			});
		}

		// Overall status pill toggle — value is kept in `selected_status`, not a form field
		fields.push(
			{
				fieldtype: "HTML",
				fieldname: "status_toggle",
				options: `<div style="margin-bottom: var(--margin-md)">
					<div class="control-label" style="margin-bottom: var(--margin-sm); font-size: var(--text-sm); color: var(--text-muted); font-weight: 400;">
						${__("Overall Status")}
					</div>
					<div class="qi-status-btns" style="display: flex; gap: 8px;">
						<button type="button" data-value="Accepted" class="btn btn-default btn-sm qi-status-btn" style="flex: 1;">
							${frappe.utils.icon("check", "sm")} ${__("Accepted")}
						</button>
						<button type="button" data-value="Rejected" class="btn btn-default btn-sm qi-status-btn" style="flex: 1;">
							${frappe.utils.icon("close", "sm")} ${__("Rejected")}
						</button>
					</div>
				</div>`,
			},
			{ fieldtype: "Small Text", fieldname: "remarks", label: __("Remarks") }
		);

		const qi_dialog = new frappe.ui.Dialog({
			title: __("Quality Inspection {0} / {1}", [idx + 1, total]),
			size: has_readings ? "extra-large" : "small",
			fields,
			primary_action_label: is_last ? __("Submit") : __("Submit & Next"),
			primary_action: async (values) => {
				qi_dialog.disable_primary_action();
				// Convert per-row Check flag back to the string status the server expects
				const readings_for_server = (values.readings || []).map((r) => ({
					reading_1: r.reading_1,
					status: r.status_accepted ? "Accepted" : "Rejected",
				}));
				try {
					await frappe.call({
						method: "erpnext.controllers.stock_controller.submit_quality_inspection",
						args: {
							qi_name,
							readings: readings_for_server,
							status: selected_status,
							remarks: values.remarks || "",
						},
						freeze: true,
					});
					frappe.show_alert({ message: __("{0} submitted", [qi_name]), indicator: "green" });
					action_taken = true;
					qi_dialog.hide();
					idx++;
					next();
				} catch {
					qi_dialog.enable_primary_action();
				}
			},
			secondary_action_label: __("Skip"),
			secondary_action: () => {
				action_taken = true;
				qi_dialog.hide();
				idx++;
				next();
			},
			onhide: () => {
				if (!action_taken) {
					idx++;
					next();
				}
			},
		});

		qi_dialog.show();

		// Render the active state on the pill toggle
		const set_active = (val) => {
			selected_status = val;
			qi_dialog.$wrapper.find(".qi-status-btn").each(function () {
				const is_active = $(this).data("value") === val;

				$(this)
					.toggleClass("btn-success", is_active && val === "Accepted")
					.toggleClass("btn-danger", is_active && val === "Rejected")
					.toggleClass("btn-default", !is_active);
			});
		};

		set_active(selected_status);
		qi_dialog.$wrapper.find(".qi-status-btns").on("click", ".qi-status-btn", function () {
			set_active($(this).data("value"));
		});
	};

	next();
};
